module.exports = __webpack_public_path__ + "x5.no1.aaade9d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/x5.no1.jpg
// module id = y8CY
// module chunks = 0